import React, {useEffect, useState} from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { setupInterceptor } from "./services/http";
setupInterceptor();

// Brand palette — makes antd use TPMready magenta instead of its default blue
// for every component (buttons, tabs, selects/inputs focus, pagination, switch,
// checkbox, radio, datepicker, progress). This removes the stray blue hover.
const BRAND = "#AA1A5F";
const BRAND_DARK = "#6A113C";
const tpmTheme = {
  token: { colorPrimary: BRAND, colorLink: BRAND, colorInfo: BRAND },
  components: {
    Tabs: {
      inkBarColor: BRAND,
      itemActiveColor: BRAND,
      itemSelectedColor: BRAND,
      itemHoverColor: BRAND,
    },
    Button: {
      colorPrimary: BRAND,
      colorPrimaryHover: BRAND_DARK,
      colorPrimaryActive: BRAND_DARK,
    },
    Select: { colorPrimary: BRAND, colorPrimaryHover: BRAND },
    Input: { colorPrimary: BRAND, activeBorderColor: BRAND, hoverBorderColor: BRAND },
    DatePicker: { colorPrimary: BRAND },
    Pagination: { colorPrimary: BRAND },
    Progress: { defaultColor: BRAND },
    Switch: { colorPrimary: BRAND },
  },
};

function FaviconUpdater() {
  const [inited, setInited] = useState(true);
  useEffect(() => {
    if(inited) {
      const favicon = document.getElementById('favicon');
      if (!favicon) return;
  
      if (process.env.REACT_APP_API_BASE_URL === "https://shareapi.tpmready.com") {
        favicon.href = process.env.PUBLIC_URL + "/favBlue.ico";
      } else {
        favicon.href = process.env.PUBLIC_URL + "/fav.ico";
      }
      setInited(false);
    }
  }, []);
  return null;
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ConfigProvider theme={tpmTheme}>
    <FaviconUpdater/>
    <App />
  </ConfigProvider>
);

reportWebVitals();
